import React, { useState } from 'react';
import Modal from 'react-responsive-modal';

import * as styles from './IframeModal.module.css';
import { PrimaryLink } from './Links';

const IframeModal = ({ content, children }) => {
  const [open, setOpen] = useState(false);

  return (
    <>
      {children ? (
        <button className={styles.clickTarget} onClick={() => setOpen(true)}>
          {children}
        </button>
      ) : (
        <div className={styles.repriseButton}>
          <PrimaryLink isButton onClick={() => setOpen(true)} label={content.contentType?.viewLabel} />
        </div>
      )}

      <Modal open={open} onClose={() => setOpen(false)} classNames={{ modal: styles.modal }}>
        <iframe src={content.ctaExternalLink} title={content.title || ''} allow="clipboard-write"></iframe>
      </Modal>
    </>
  );
};

export default IframeModal;
